import { render, staticRenderFns } from "./SignInOIDCError.vue?vue&type=template&id=15a99c76"
import script from "./SignInOIDCError.vue?vue&type=script&lang=ts"
export * from "./SignInOIDCError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a99c76')) {
      api.createRecord('15a99c76', component.options)
    } else {
      api.reload('15a99c76', component.options)
    }
    module.hot.accept("./SignInOIDCError.vue?vue&type=template&id=15a99c76", function () {
      api.rerender('15a99c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/authentication/OIDC/SignInOIDCError.vue"
export default component.exports